<template>
  <div class="container">
    <router-view />
  </div>
</template>

<style>
#hs-eu-cookie-confirmation {
  display: none !important;
}
.policy-holder {
  font-size: 14px !important;
}
.helper-text {
  color: #ff723d !important;
  font-size: 11px !important;
}
.action {
  color: #ff0064;
}
.btn-action:disabled,
.btn-action.disabled {
  color: #fff;
  background-color: #000C19;
  border-color: #000C19;
  cursor: not-allowed;
  opacity: 1 !important;
}
.btn-action {
  border-radius: 2rem !important;
  color: #fff !important;
  background-color: #000C19 !important;
  border-color: #000C19 !important;
}
.form-group.required .control-label:after {
  content: "*";
  color: #dc3545;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
h4 {
  color: #444;
  margin-bottom: 30px;
}
.error-message {
  color: #dc3545;
  font-size: 11px;
  margin: 0;
}
.success-message {
  color: #0f5132;
  font-size: 11px;
  margin: 0;
}
.info-message {
  color: #055160;
  font-size: 11px;
  margin: 0;
}
.error-wrapper {
  min-height: 19px;
  margin-top: 0;
}
.form-container {
  margin: auto;
  padding-top: 30px;
  width: 400px;
}
.btn-container {
  text-align: center;
}
</style>
